module.exports = __webpack_public_path__ + "img/sample-m-1.399f5e95.jpeg";